const AudioManager = require('AudioManager');

const scaleUp = { scale: 1.2 };
const scaleDown = { scale: 1 };
const scaleTime = 0.2;
const toPos = { x: -100 };

cc.Class({
    extends: cc.Component,

    properties: {
        skeleton: sp.Skeleton,
        title: cc.Sprite,
        bigFrame: cc.SpriteFrame,
        megaFrame: cc.SpriteFrame,
        epicFrame: cc.SpriteFrame,
    },

    onLoad () {
        this.audioManager = cc.find('AudioManager').getComponent(AudioManager);
        this.skeleton.setCompleteListener((event) => {
            switch (event.animation.name) {
                // case '1BIGWINstart':
                case '1BIGWINidle':
                // case '2MEGAWINstart':
                case '2MEGAWINidle':
                // case '3EPICWINstart':
                case '3EPICWINidle':
                    // this.node.emit('hide');
                    break;
            }
        })
    },

    show (index) {
        if (!this.node.active) {
            this.node.active = true;
        }

        if (this.index === index) {
            return;
        }

        this.index = index;
        switch (index) {
            case 0:
                this._titleSpriteShow();
                this.skeleton.setAnimation(0, '1BIGWINstart', false);
                this.skeleton.addAnimation(0, '1BIGWINidle', true);
                this.skeleton.node.x = 0;
                cc.tween(this.skeleton.node).delay(1).to(0.3, toPos).start();
                break;
            case 1:
                this.skeleton.node.x = toPos.x;
                this._titleSpriteUpdate(this.megaFrame);
                this.skeleton.setAnimation(0, '2MEGAWINstart', false);
                this.skeleton.addAnimation(0, '2MEGAWINidle', true);
                break;
            case 2:
                this.skeleton.node.x = toPos.x;
                this._titleSpriteUpdate(this.epicFrame);
                this.skeleton.setAnimation(0, '3EPICWINstart', false);
                this.skeleton.addAnimation(0, '3EPICWINidle', true);
                break;
        }
    },

    _titleSpriteUpdate(newFrame) {
        if (this.title.spriteFrame === newFrame) {
            return;
        }

        this._cleanTween();
        this.titleTween = cc.tween(this.title.node).
        to(scaleTime, scaleUp).
        call(() => this.title.spriteFrame = newFrame).
        to(scaleTime, scaleDown).
        call(this._cleanTween, this).
        start();
    },

    _titleSpriteShow() {
        this.title.spriteFrame = this.bigFrame;
        this.title.node.scale = 0;

        this._cleanTween();
        this.titleTween = cc.tween(this.title.node).
        to(scaleTime, scaleUp, { easing: 'backOut' }).
        call(this._cleanTween, this).
        start();
    },


    _cleanTween() {
        if (this.titleTween) {
            this.titleTween.stop();
            this.titleTween = null;
        }
    },

    hide () {
        this.index = null;
        this.node.active = false;
    },

});
